var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[(this.hasMemberPermission('library_edit'))?_c('CreateLibraryPost',{attrs:{"library":_vm.library}}):_vm._e(),(_vm.show_loading)?_c('Loading'):_c('ShowLibraryPosts',{attrs:{"library":_vm.library}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }